import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ element, adminOnly = false }) => {
    const { user, loading } = useAuth();

    if (loading) return <div className="page-loading">Loading...</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly && !user.is_admin) return <Navigate to="/" replace />;
    return element;
};

export default PrivateRoute;
